import axios, { AxiosHeaders } from 'axios';
import { validateTokens } from '../helpers/getTokens.helper';

const IamApi = axios.create({
    baseURL: process.env.REACT_APP_API_MARKET_PLACE,
});

IamApi.interceptors.request.use(async (config) => {
    const { accessToken } = await validateTokens();
    (config.headers as AxiosHeaders).set("Authorization", `Bearer ${accessToken}`);
    (config.headers as AxiosHeaders).set("Accept", 'application/json, application/vnd.weir-iamservice.v1');
    return config;
});

IamApi.interceptors.response.use((response) => {
    const { data } = response;
    if (data?.status == 0) {
        throw new Error(data?.message);
    }
    return response.data;
});

export default IamApi;
